(ns common.schema.entities.sales-opportunity.permissions
  (:require [common.schema.entities.permissions :as entity-permissions]))

(defn read-permissions?
  [{:keys [account-current-permissions entity]}]
  (and (contains? (:account-modules account-current-permissions)
                  :module/sales-pipelines)
       (contains? (:account-access-to-pipelines account-current-permissions)
                  (-> entity
                      :sales-opportunity/pipeline
                      :db/id))))

(defn disable-permissions?
  [ctx]
  (entity-permissions/disable-when-no-write-permission ctx))
